var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var SearchMeetIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '22' : _b, _c = _a.height, height = _c === void 0 ? '20' : _c;
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 22 20", fill: "currentColor", className: "inline-block" }, { children: _jsx("path", { d: "M9 16H2C0.9 16 0 15.1 0 14V2C0 0.9 0.9 0 2 0H3L5 4H8L6 0H8L10 4H13L11 0H13L15 4H18L16 0H20V9C19.5 8.2 18.8 7.5 18 7V6H3.8L2 2.5V14H8.2C8.4 14.7 8.6 15.4 9 16ZM18.3 14.9C18.7 14.2 19 13.4 19 12.5C19 10 17 8 14.5 8C12 8 10 10 10 12.5C10 15 12 17 14.5 17C15.4 17 16.2 16.8 16.9 16.3L20 19.4L21.4 18L18.3 14.9ZM14.5 15C13.1 15 12 13.9 12 12.5C12 11.1 13.1 10 14.5 10C15.9 10 17 11.1 17 12.5C17 13.9 15.9 15 14.5 15Z", fill: "currentColor" }) })));
};
export default SearchMeetIcon;
